export default __webpack_public_path__ + "static/media/icon-qr-appcoopeuch-appstore-googleplay.5213c4ca.png";